import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { API_URL } from '@core/constants';
import { ICDCode, IDiagnosisResponseDTO } from '@core/model';
import { ApplicationStateService } from './application-state.service';
import { AuthorizationStateService } from '@app/feature/authorization-details/authorization-state.service';

@Injectable({
  providedIn: 'root',
})
export class DiagnosisService {
  constructor(
    private http: HttpClient,
    private applicationStateService: ApplicationStateService,
    private authorizationStateService: AuthorizationStateService,
    @Inject(API_URL) private apiUrl: string
  ) {
  }

  private get baseUrl(): string {
    return `${this.apiUrl}/api/tenants/${this.applicationStateService.tenantId}`;
  }

  getIcdCodesBySearch(code: string): Observable<ICDCode[]> {
    return this.http.get<ICDCode[]>(`${this.baseUrl}/Diagnoses?code=${code}`);
  }

  setIcdCodes(ICDcodes: ICDCode[], authorizationByProductId: string): Observable<ICDCode[]> {
    return this.http.put<ICDCode[]>(
      `${this.baseUrl}/authorizations/${authorizationByProductId}/Diagnoses`, this.transformIcdCodes(ICDcodes)
    );
  }

  getDiagnosesForAuthorization(authorizationByProductId: string): Observable<IDiagnosisResponseDTO> {
    this.authorizationStateService.hasNoICDCodes$.next(false);
    return this.http
      .get<IDiagnosisResponseDTO>(`${this.baseUrl}/authorizations/${authorizationByProductId}/Diagnoses`)
      .pipe(tap(res => {
        if (!res.current.length && !res.original.length) {
          this.authorizationStateService.hasNoICDCodes$.next(true);
        }
      }));
  }

  private transformIcdCodes(codes: ICDCode[]) {
    const transformedCodes = [];
    codes.forEach((elem, index) => {
      const { code, description, isActive, pdgm } = elem;
      transformedCodes[index] = {
        icdCodeID: elem['icdCodeID'],
        icdCode: { code, description, isActive, pdgm },
      };
      index === 0
        ? (transformedCodes[index]['icdOrderType'] = 'Primary')
        : null;
    });
    return transformedCodes;
  }
}
